import { buildTranslate } from 'locales'

const t = buildTranslate('components.ai.segment_activation_modal')

interface RememberChoiceCheckboxProps {
  checked: boolean
  onChange: () => void
}

const RememberChoiceCheckbox = ({
  checked,
  onChange,
}: RememberChoiceCheckboxProps) => (
  <label className="segment-activation-modal__checkbox mt-xs">
    <input type="checkbox" checked={checked} onChange={onChange} />
    <span>{t('remember_checkbox')}</span>
  </label>
)

export default RememberChoiceCheckbox
